export default {
  id: 'molten.Logout',
  sort: -1,
  onLoggedOut: async molten => {
    localStorage.removeItem('redirectUrl');
    localStorage.removeItem('lastActivePage');
    window.location.href = '/';
  }
};